import script from "./NavBer.vue?vue&type=script&setup=true&lang=js"
export * from "./NavBer.vue?vue&type=script&setup=true&lang=js"

import "./NavBer.vue?vue&type=style&index=0&id=56263a08&scope=true&lang=scss"

const __exports__ = script;

export default __exports__